import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal } from "../Reveal";
import { IMG, COMPANY } from "../../data/content";

export const CTASection = () => (
  <section data-testid="cta-section" className="relative overflow-hidden">
    <div className="absolute inset-0">
      <img src={IMG.lawn} alt="Professionally maintained commercial property" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-sml-forest/90" />
    </div>
    <div className="relative mx-auto max-w-4xl px-5 lg:px-8 py-28 lg:py-36 text-center">
      <Reveal>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-white text-balance">
          Let's Create Better Environments Together
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-8 text-white/80 text-lg leading-relaxed max-w-2xl mx-auto">
          Every property deserves professional care and attention. Let us help you create cleaner
          facilities, healthier workplaces and greener outdoor spaces that leave a lasting impression.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-proposal-button"
            className="group inline-flex items-center gap-2 rounded-sm bg-sml-bronze text-sml-forest font-semibold px-8 py-4 hover:bg-white transition-colors active:scale-[0.98]"
          >
            Request a Service Proposal
            <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <a
            href={COMPANY.phoneHref}
            data-testid="cta-call-button"
            className="inline-flex items-center gap-2 rounded-sm border border-white/40 text-white font-medium px-8 py-4 hover:bg-white/10 transition-colors"
          >
            <Phone className="h-4 w-4" /> Contact SML Property Solutions
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
